import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  submitForm() {
    const form = event.currentTarget.closest("form");
    if (form) {
      Rails.fire(form, "submit");
    }
  }
}
